import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import api from '../../../config/axios';
import Swal from 'sweetalert2';

import { FaTimes } from 'react-icons/fa';

const OperacaoDetalhesModal = ({ onClose, operacao }) => {
    const navigate = useNavigate();
    const [itens, setItens] = useState([]);

    useEffect(() => {
        const abrirComanda = async () => {
            if (operacao.id_comanda) {
                Swal.fire({
                    title: "Carregando...",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });

                try {
                    const response = await api.get(`/comandas/${operacao.id_comanda}`);
                    setItens(response.data.itens || []);
                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Erro!',
                        text: 'Não foi possível carregar os itens da comanda.'
                    });
                } finally {
                    Swal.close();
                }
            }
        }
        abrirComanda();
    }, [operacao.id_comanda]);

    const handleAbrirComanda = () => {
        const statusFechados = ['pago', 'finalizado', 'cancelado', 'faltou'];
        const tab = statusFechados.includes(operacao.status) ? 'finalizadas' : 'abertas';
        const rotaComanda = `/financeiro/comandas?tab=${tab}&comanda=${operacao.id_comanda}`;
            
        navigate(rotaComanda);
        onClose();
    };

    return (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-header">
                        <h4 className="fw-bold mt-2">Detalhes</h4>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>

                    <div className="modal-body">
                        <div className="row">
                            <div className="col-12">
                                <h6 className="fw-bold">Cliente</h6>
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className="col-lg-6 col-12">
                                <span className="fw-bold">Nome: </span>
                                <span>{operacao.cliente.nome}</span>
                            </div>
                        </div>
                        {!operacao.id_comanda && (
                            <div>
                                <hr />
                                <div className="row mt-4">
                                    <div className="col-12">
                                        <h6 className="fw-bold">Serviço</h6>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-lg-6 col-12">
                                        <span className="fw-bold">Nome: </span>
                                        <span>{operacao.servico.nome}</span>
                                    </div>
                                    <div className="col-lg-6 col-12 mt-lg-0 mt-3">
                                        <span className="fw-bold">Valor: </span>
                                        <span>{parseFloat(operacao.servico.preco).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-lg-6 col-12 mt-lg-0 mt-3">
                                        <span className="fw-bold">Horário: </span>
                                        <span>{operacao.hora_inicio} - {operacao.hora_termino}</span>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-lg-6 col-12 mt-lg-0 mt-3">
                                        <span className="fw-bold">Colaborador: </span>
                                        <span>{operacao.colaborador?.nome || "-"}</span>
                                    </div>
                                </div>
                                <hr />
                            </div>
                        )}
                        {operacao.id_comanda && itens.length > 0 && (
                            <div>
                                {itens.some(item => item.tipo_item === "servico") && (
                                    <div>
                                        <hr />
                                        <div className="row mt-4">
                                            <div className="col-12">
                                                <h6 className="fw-bold">Serviços</h6>
                                            </div>
                                        </div>
                                        {itens
                                            .filter(item => item.tipo_item === "servico")
                                            .map((item) => (
                                                <div key={item.id} style={{ borderBottom: '1px solid #ccc', padding: '10px 0px' }}>
                                                    <div className="row mt-2">
                                                        <div className="col-lg-6 col-12">
                                                            <span className="fw-bold">Nome: </span>
                                                            <span>{item.servico.nome}</span>
                                                        </div>
                                                        <div className="col-lg-3 col-12 mt-lg-0 mt-2">
                                                            <span className="fw-bold">Valor: </span>
                                                            <span>{parseFloat(item.valor_item).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
                                                        </div>
                                                        <div className="col-lg-3 col-12 mt-lg-0 mt-2">
                                                            <span className="fw-bold">Quantidade: </span>
                                                            <span>{item.qtd}</span>
                                                        </div>
                                                    </div>
                                                    <div className="row mt-2">
                                                        <div className="col-lg-6 col-12">
                                                            <span className="fw-bold">Colaborador: </span>
                                                            <span>{item.colaborador?.nome || "-"}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                    </div>
                                )}

                                {itens.some(item => item.tipo_item === "produto") && (
                                    <div>
                                        <div className="row mt-4">
                                            <div className="col-12">
                                                <h6 className="fw-bold">Produtos</h6>
                                            </div>
                                        </div>
                                        {itens
                                            .filter(item => item.tipo_item === "produto")
                                            .map((item) => (
                                                <div key={item.id} style={{ borderBottom: '1px solid #ccc', padding: '10px 0px' }}>
                                                    <div className="row mt-2">
                                                        <div className="col-lg-6 col-12">
                                                            <span className="fw-bold">Nome: </span>
                                                            <span>{item.produto.nome}</span>
                                                        </div>
                                                        <div className="col-lg-3 col-12 mt-lg-0 mt-2">
                                                            <span className="fw-bold">Valor: </span>
                                                            <span>{parseFloat(item.valor_item).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
                                                        </div>
                                                        <div className="col-lg-3 col-12 mt-lg-0 mt-2">
                                                            <span className="fw-bold">Quantidade: </span>
                                                            <span>{item.qtd}</span>
                                                        </div>
                                                    </div>
                                                    <div className="row mt-2">
                                                        <div className="col-lg-6 col-12">
                                                            <span className="fw-bold">Colaborador: </span>
                                                            <span>{item.colaborador?.nome || "-"}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                    </div>
                                )}
                            </div>
                        )}
                        <div className="row mt-4">
                            <div className="col-12">
                                <h6 className="fw-bold">Outras Informações</h6>
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className="col-lg-6 col-12">
                                <span className="fw-bold">Horário: </span>
                                <span>{operacao.hora_inicio} - {operacao.hora_termino}</span>
                            </div>
                            <div className="col-lg-6 col-12 mt-lg-0 mt-2">
                                <span className="fw-bold">Status: </span>
                                <span>{operacao.status.substring(0, 1).toUpperCase() + operacao.status.substring(1)}</span>
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className="col-lg-6 col-12">
                                <span className="fw-bold">Observações: </span>
                                <span>{operacao.observacao}</span>
                            </div>
                            {operacao.id_comanda && (
                                <div className="col-lg-6 col-12 mt-lg-0 mt-2">
                                    <span className="fw-bold me-2">Comanda Nº {operacao.id_comanda}</span>
                                    <button className="btn btn-outline-primary" onClick={handleAbrirComanda}>Abrir Comanda</button>
                                </div>
                            )}
                        </div>

                    </div>
                    <div className="modal-footer mt-4">
                        <div className="row">
                            <div className="col-12 text-end">
                                <button className="btn btn-outline-danger" type="button" onClick={onClose}>
                                    <FaTimes /> Fechar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default OperacaoDetalhesModal;
